import React from 'react';
import { useSelector, useDispatch } from 'react-redux';

import {
  TabsContainer,
  Tabs,
  Tab,
  TabPanelsContainer,
  TabPanel
} from 'react-magma-dom';

import { SummaryDataTab } from './Tabs/SummaryData/Component';
import { PostHocAnalysis } from './Tabs/PostHocAnalysis/Component';
import { SideBySideBoxPlots } from './Tabs/SideBySideBoxPlots/Component';

import { setParametersInferentialStatistics } from 'store/scenes/inferentialStatistics/actions';
import {
  getActiveIndexTabAnova
} from 'store/scenes/inferentialStatistics/selectors';

import { getVisibleNumericalSelectedParametersNames, getVisibleCategoricalSelectedParametersNames, isFrequencyOrContingencyTable } from 'store/dataset';

const AnovaContainer = () => {
  const dispatch = useDispatch();
  const activeIndexTabAnova = useSelector(state => getActiveIndexTabAnova(state));
  const isDatasetTypeFrequency = useSelector(state => isFrequencyOrContingencyTable(state));
  const isDatasetScenario = !isDatasetTypeFrequency && useSelector(state => getVisibleNumericalSelectedParametersNames(state).length > 0 &&
  getVisibleCategoricalSelectedParametersNames(state).length > 0);
  const handleChange = index => {
    const value = {
      activeIndexTabAnova: index
    };
    dispatch(setParametersInferentialStatistics(value));
  };

  return (
    <TabsContainer activeIndex={activeIndexTabAnova ? activeIndexTabAnova : 0}>
      <Tabs onChange={handleChange}>
        <Tab>Summary Data</Tab>
        <Tab>Post Hoc Analysis</Tab>
        {isDatasetScenario &&
          <Tab>Side-by-side Boxplots</Tab>
        }
      </Tabs>
      <TabPanelsContainer >
        <TabPanel>
          <SummaryDataTab />
        </TabPanel>
        <TabPanel>
          <PostHocAnalysis />
        </TabPanel>
        <TabPanel>
          <SideBySideBoxPlots />
        </TabPanel>
      </TabPanelsContainer>
    </TabsContainer>
  );
};

export default AnovaContainer;
